import React, { useContext } from 'react';
import { useBannerData } from './BannerDataProvider';
import Carousel from './Carousel';
import { UserContext } from '../../data/betslip/UserConf';

export default function BannersCarousel({ onlyGroup = null }) {
    const bannerData = useBannerData();
    const userContext = useContext(UserContext)

    if (!bannerData?.carouselBanners?.length) {
        return null;
    }

    let banners = bannerData.carouselBanners;
    if (banners != null) {
        if (userContext.getUser()?.logged) {
            banners = banners.filter(b => b.onlyLogged || !b.onlyUnlogged);
        } else {
            banners = banners.filter(b => b.onlyUnlogged || !b.onlyLogged);
        }
    }
    
    const bannersByGroup = banners.reduce((acc, banner) => {
        const group = banner.carouselGroup ?? 0;
        if (!acc[group]) acc[group] = [];
        acc[group].push(banner);
        return acc;
    }, {});
    
    let bannersToShow = [];
    
    if (onlyGroup === null) {
        bannersToShow = [
            ...(bannersByGroup[0] || []),
            ...(bannersByGroup[1] || []),
        ];
    } else if (Array.isArray(onlyGroup)) {
        onlyGroup.forEach((g) => {
            bannersToShow.push(...(bannersByGroup[g] || []));
        });
    } else {
        bannersToShow = bannersByGroup[onlyGroup] || [];
    }
    
    if (!bannersToShow.length) return null;
    
    return (
        <div className="xs_bannersCarousel relative mx-2 my-2">
            <Carousel banners={bannersToShow} />
        </div>
    );
}
